import { ErrorHandler, inject, Injectable } from "@angular/core";
import { WeblogEndpoint, WebLoggerService } from "./web-logger.service";

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  private webLogger = inject(WebLoggerService)

  constructor() {
    window.addEventListener('error', event => this.handleError(event))
    window.addEventListener('unhandledrejection', event => this.handleError(event))
  }

  handleError(error: any) {
    console.error(error)
    const obj = this.formatError(error)
    if (obj) {
      this.webLogger.reportError(WeblogEndpoint.uiError, obj)
    }
  }

  private formatError(error: any): any {
    let obj: any = undefined
    if (error instanceof ErrorEvent) {
      obj = {
        url: location.href,
        name: 'ErrorEvent',
        message: error.message,
        line: error.lineno,
        col: error.colno,
        filename: error.filename,
        error: this.formatError(error.error),
      }
    }
    else if (error instanceof PromiseRejectionEvent) {
      obj = {
        url: location.href,
        name: 'PromiseRejectionEvent',
        type: error.type,
        reason: this.formatError(error.reason),
      }
    }
    else if (error instanceof Error) {
      obj = {
        url: location.href,
        name: error.name,
        message: error.message,
      }
      if (error.cause) {
        obj.cause = error.cause
      }
      if (error.stack) {
        if (error.stack.includes('chrome-extension://')) {
          return undefined
        }
        obj.stack = error.stack
      }
    }
    else if (typeof(error) == 'string') {
      obj = {
        url: location.href,
        message: error,
      }
    }

    return obj
  }

}
